import { SourcingService } from 'api-clients/monolith';

/* eslint-disable camelcase */
interface ValidateSourcingPurchasesParams {
  channel_slug: string;
  start_date: string;
  end_date: string;
  opening_ids: string[];
}
/* eslint-enable camelcase */

export function validateSourcingPurchases(
  params: ValidateSourcingPurchasesParams,
) {
  return SourcingService.postInternalApiSourcingSourcingPurchasesValidateSourcingPurchases(
    params,
  );
}
